import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { CarePath } from '../../types/content';
import { useBrand } from '../../contexts/BrandContext';
interface CarePathTableProps {
  items: CarePath[];
}
export function CarePathTable({
  items
}: CarePathTableProps) {
  const {
    carePathImage
  } = useBrand();
  if (items.length === 0) {
    return <p className="rule mt-10 pt-10 text-ink-soft" data-id="element-60" data-mp="2rxzs9jvrox33">
        Nothing in that category yet. Try another, or tell us what you were looking for.
      </p>;
  }
  return <ul className="mt-10" data-id="element-61" data-mp="2n1ivy2eezcex">
      {items.map(path => <li key={path.slug} className="rule" data-id="element-62" data-mp="2i7576iu9c3j8">
          <Link to={`/care/${path.slug}`} className="group grid gap-5 py-8 transition-colors duration-150 ease-brand md:grid-cols-[auto_1.1fr_1.4fr_auto] md:items-center md:gap-10" data-id="element-63" data-mp="2e6uqoc8u9uq4">
            <img src={carePathImage(path.slug, path.image)} alt="" className="h-20 w-28 rounded-brand object-cover" loading="lazy" data-id="element-64" data-mp="35yajio0zodos" />
            <div data-id="element-65" data-mp="1wzt1ia6p4p24">
              <p className="text-[0.6875rem] uppercase tracking-label text-brick" data-id="element-66" data-mp="1wy86kjggz43q">
                {path.category}
              </p>
              <h3 className="mt-2 font-serif text-2xl leading-snug text-ink md:text-[1.75rem]" data-id="element-67" data-mp="1ia3n3d9leojw">
                {path.name}
              </h3>
            </div>
            <p className="leading-relaxed text-ink-soft" data-id="element-68" data-mp="199fh95ucrui3">{path.summary}</p>
            <div className="flex items-center gap-6 md:justify-end" data-id="element-69" data-mp="1e8iei443cwfi">
              <p className="whitespace-nowrap text-sm text-ink-soft" data-id="element-70" data-mp="1e6p3ydqcxs28">
                From ${path.priceFrom}
                <span className="text-ink-muted" data-id="element-71" data-mp="zdvr702gzq19"> {path.cadence}</span>
              </p>
              <ArrowRightIcon className="h-5 w-5 shrink-0 text-brick transition-transform duration-150 ease-brand group-hover:translate-x-1" aria-hidden="true" data-id="element-72" data-mp="14coslu4hfql2" />
            </div>
          </Link>
        </li>)}
    </ul>;
}